import { render, staticRenderFns } from "./support-manage.vue?vue&type=template&id=6b7e8350&"
import script from "./support-manage.vue?vue&type=script&lang=js&"
export * from "./support-manage.vue?vue&type=script&lang=js&"
import style0 from "./support-manage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports